
import { Animated, Image, StyleSheet, View } from 'react-native';

import Images from '../../state/stores/Image/images';
import PressableScale from '../PressableScale/PressableScale';
import Show from '../Show/Show';
import { Caption1Bold } from '../../config/designSystem/typography';
import { useAvailableDimensions } from '../../hooks/ui/useAvailableDimensions';
import { useRef } from 'react';


const borderRadius = 12;
const height = 90;
interface SectionItemProps {
  onPress: () => void;
  text: string;
  backgroundColor?: string;
  textColor?: string;
  fullWidth?: boolean;
  nameImage?:keyof typeof Images['assistance'];
  positionImage?: 'top' | 'bottom' | 'left';
  widthImage?: number;
  heightImage?: number;
}
export const SectionItem = ({
  onPress,
  text,
  backgroundColor,
  textColor,
  fullWidth,
  nameImage,
  positionImage,
  widthImage,
  heightImage
}: SectionItemProps) => {
  const scaleAnimation = useRef(new Animated.Value(1)).current;
  const {width} = useAvailableDimensions();
  const widthRatio = fullWidth ? 0.8 : 0.38;
  const widthBox = Math.max(150,widthRatio*width);
  const adjustedWidthImage = Math.min(widthBox,widthImage || 150);
  return (
    <PressableScale
      scaleAnimation={scaleAnimation}
      onPress={onPress}
      style={{width: Math.max(150,widthRatio*width), height  }}
    >
      <Animated.View
        style={[styles.animated, {
          transform: [{ scale: scaleAnimation }],
          backgroundColor,
        }]}
      >
        <View style={styles.content}>
          <Caption1Bold
            align={true}
            color={textColor}
          >
            {text}
          </Caption1Bold>
        </View>
        <Show when={nameImage} keyed>
          {name => (
            <View
              style={[
                styles.imageWrap,
                positionImage === 'top' ? styles.imageWrapTop : (positionImage === 'bottom'?styles.imageWrapBottom: styles.imageWrapLeft),
                {
                  width: adjustedWidthImage,
                  height: heightImage,
                }]}
            >
              <Image
                source={Images['assistance'][name]}
                width={adjustedWidthImage}
                height={heightImage}
                style={styles.image}
              />
            </View>)}
        </Show>
      </Animated.View>
    </PressableScale>
  );
};

const styles = StyleSheet.create({
  animated: {
    padding: 22,
    flex:1,
    borderRadius,
    overflow: 'hidden',
  },
  content: {
    zIndex: 1,
    maxWidth: '90%',
    justifyContent: 'center',
    alignItems:'center',
    flex:1,
  },
  imageWrap: {
    position:'absolute',
    right:0,
    borderRadius,
  },
  imageWrapLeft: {
    left: 0,
  },
  imageWrapTop: {
    top: 0,
  },
  imageWrapBottom: {
    bottom: 0,
  },
  image: {
    width: '100%',
    height: '100%',
    borderRadius,
  }
});
